import { IonContent, IonFooter, IonHeader, IonModal } from '@ionic/react'
import React from 'react'
import { observer } from 'mobx-react'
import { cartMobx, orderMobx } from 'restaurant'
import { ddayjs, format, toPriceLittleCurrency } from '@dt/fe-utils'
import './index.scss'

interface IProps {
  reject?: () => void;
  resolve?: (product: any) => void;
}

const ExpressPriceModal: React.FC<IProps> = (props) => {
  const ExpressPrice = (item: IOrderDetail) => {
    let startTime = item.startTime
    try {
      let productExt = item?.productExt && JSON.parse(item?.productExt)
      startTime = productExt.arriveTime
    } catch (e) {
    }
    return (
      <div className='bpm-item'>
        <span>{i18n.t('newCart.timeFor_delivery', { time: ddayjs(item.startTime, 'client').format('YYYY-MM-DD HH:mm') })}</span>
        <span>{format.toPrice(item.paidFee)}</span>
      </div>
    )
  }

  const handleClose = () => {
    props.reject()
  }

  return (
    <IonModal
      cssClass='express-price-modal'
      isOpen
      showBackdrop
      swipeToClose
      backdropDismiss={false}
    >
      <IonHeader>
        <div className='bpm-title'>{i18n.t('result.expressPriceDetail')}</div>
      </IonHeader>
      <IonContent className='bpm-content'>
        <div className='bpm-list'>
          {orderMobx.viewOrder?.expressItem.map(item => (
            <ExpressPrice key={item.pk} {...item} />
          ))}
        </div>
        <div className='bpm-total'>
          <span>{i18n.t('cart.total')} </span>
          <span dangerouslySetInnerHTML={{ __html: toPriceLittleCurrency(orderMobx.viewOrder.expressPrice) }}></span>
        </div>
      </IonContent>
      <IonFooter className='bpm-footer'>
        <button className='default-btn' data-cypid='expressPriceModalClose' onClick={handleClose}>
          {i18n.t('common.back')}
        </button>
      </IonFooter>
    </IonModal>
  )
}

export default observer(ExpressPriceModal)
